import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignKoggenlandPage() {
  return <LocalPageTemplate city="Koggenland" introText="Professionele websites voor ondernemers in Koggenland. Van Obdam tot De Goorn. Wij bouwen websites die jouw bedrijf laten groeien in West-Friesland." localContext="Koggenland is een landelijke, groene gemeente in West-Friesland met kernen als Obdam, De Goorn, Avenhorn en Hensbroek. De regio kenmerkt zich door agrarische bedrijvigheid, lokale retail en een sterke gemeenschapszin. Voor ondernemers in Koggenland is een professionele website essentieel om niet alleen in het eigen dorp, maar in de hele regio (inclusief Hoorn en Heerhugowaard) goed gevonden te worden." nearbyLocations={[{
    name: 'Hoorn',
    slug: 'hoorn'
  }, {
    name: 'Opmeer',
    slug: 'opmeer'
  }, {
    name: 'Drechterland',
    slug: 'drechterland'
  }, {
    name: 'Alkmaar',
    slug: 'alkmaar'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Koggenland?',
    a: 'Een professionele website voor een ondernemer in Koggenland start vanaf €1.500. We bespreken altijd eerst jouw doelen en maken op basis daarvan een transparante offerte zonder verborgen kosten.'
  }, {
    q: 'Hoe bereik ik klanten buiten mijn eigen dorp?',
    a: 'We optimaliseren je website voor zoektermen in Koggenland én de bredere regio (Hoorn, Alkmaar, Opmeer). Juist in landelijke gemeenten is online vindbaarheid de sleutel om klanten uit een groter gebied aan te trekken.'
  }, {
    q: 'Bouwen jullie ook websites voor lokale ambachtslieden?',
    a: "Ja, Koggenland kent veel vakmensen en ambachtslieden. Wij bouwen websites met projectportfolio's en referenties die jouw vakmanschap professioneel presenteren aan potentiële opdrachtgevers in de regio."
  }]} data-id="element-1846" />;
}